import moment from 'moment';

import { ExpiringMarkup } from '@mitsubishi/pricing-list/data-access';

const FRIDAY = 5;

/**
 * Markups inside the "last day to act" window: normally only tomorrow, but on
 * Friday the window covers Sat/Sun/Mon (the user won't act over the weekend).
 */
export const getBlockingExpiringMarkups = (
  markups: ExpiringMarkup[],
  today: moment.Moment = moment()
): ExpiringMarkup[] => {
  const start = today.clone().startOf('day');
  const blockingDays = start.day() === FRIDAY ? 3 : 1;
  const windowStart = start.clone().add(1, 'day');
  const windowEnd = start.clone().add(blockingDays, 'days').endOf('day');

  return markups.filter(markup =>
    moment(markup.startValidityDate).isBetween(windowStart, windowEnd, undefined, '[]')
  );
};
